import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ROUTE_FRAGMENT } from './fragments';

export const MARK_CUSTOMER_PICKUP_STOPS_COMPLETE = gql`
  ${ROUTE_FRAGMENT}
  mutation ${PRODUCT}MarkCustomerPickupStopsComplete(
    $input: MarkCustomerPickupStopsCompleteInput!
  ) {
    markCustomerPickupStopsComplete(input: $input) {
      routes {
        ...RouteFragment
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
        ... on NonCustomerPickupStops {
          errorCode
          stopIds
        }
      }
    }
  }
`;
